// Free $35 SIM
// if (window.boostProductTags) {
//   if( !boostProductTags.includes('bundle') && !boostProductTags.includes('accessories') && !boostProductTags.includes('Smart Watch') ) {
//     $(".product-meta").prepend(
//       '<p class="boost-callout-losange boost-now-on-5g">Free $35 SIM</p>'
//     );
//   }
// }
// Free $35 SIM

var datetime;
var height;
var width;
var width_main;

// SCALING START
function scaling(width, height) {
    if(width > 1023) {

if(width > 1480 && width ){
//if(width > 1536){
    fontSize = 1;
    //fontSize = 0.8;
} else {
    fontSize = (width - 80)/1400;
  fontSize = (width)/1480;
}

    }
  
if(width < 1024){

if(width > 479){
  fontSize = width/983;
}
  
    else {
      fontSize = width/479;
      fontSize = width/412;
      fontSize = width/434;
    }
}
  //jQuery('html').css('font-size', fontSize / 16 + 'em');
  jQuery('html').css('font-size', fontSize + 'px');
}
// SCALING END

  height = $(window).height();
  width = $(window).width();
  //width_main = $('#primary').width();
  //width_scrollbar = width - width_main;
  scaling(width, height);

function priceResize() {
  $('.promo-price').each(function(){
    var html = $(this).html();
    if ( !(html.indexOf('<span> .') > -1 ) ) {
        if (html.indexOf('.') > -1) {
        html = html.replace('.', '<span> .') + '</span>';
        $(this).html(html);
      }
    }
  });
}

priceResize();

jQuery(window).on("load resize",function(e){
  height = $(window).height();
  width = $(window).width();
  //width_main = $('#primary').width();
  //width_scrollbar = width - width_main;
  scaling(width, height);

priceResize();
  
});

// CART POPUP
if( $('body').hasClass('page-cart') ) {

var timesRun = 0;
int = setInterval(function(){
    timesRun += 1;
    if(timesRun === 10 || $('.ufeWrapper').length > 0 ){
        clearInterval(int);
    }
    //do whatever here..
	console.log('runs: ' + timesRun + ', time: ' + timesRun * 500);

  $('.ufeWrapper').append('<a style="text-decoration: underline;" target="_blank" href="https://cdn.shopify.com/s/files/1/0490/0896/7844/files/CIS_230421.pdf">Terms and conditions</a>');
  console.log('pop fix:');


}, 500);
}
// CART POPUP


// DESTINATIONS TABLE
var table_id = '';
var rowsTable = [];

function destinationsTable() {

  


$( ".boost-table-wrap" ).each( function( index ) {
    table_id = 'boost-table-wrap-' + index;
    $(this).attr('data-table-number', index );

    $(this).attr('id', table_id );
    table_id = '#' + table_id;

    
    
    console.log( table_id );




$( table_id ).load( "//cdn.shopify.com/s/files/1/0490/0896/7844/files/" + $( table_id ).attr( "data-table" ) + '.txt', function() {

table_id = '#' + $(this).attr('id');
index = $(this).attr('data-table-number');


$(table_id + ' .boost-table-input').attr('data-table-number', index );
console.log( table_id );

$( table_id + ' tbody tr').addClass('row-show');

$(table_id + " .row-show:even").addClass("row-even");

rowsTable[index] = $(table_id + ' .boost-table tbody tr');

console.log('rowsTable: ' + rowsTable);

$(table_id + ' .boost-table-input').keyup(function() {


    index = $(this).attr('data-table-number');

    var valInput = $.trim($(this).val()).replace(/ +/g, ' ').toLowerCase();
    
    rowsTable[index].css('background-color', '').removeClass('row-even').removeClass('dn').addClass('row-show').filter(function() {
        var textSearch = $(this).text().replace(/\s+/g, ' ').toLowerCase();
        //console.log('textSearch: ' + textSearch + ', valInput: ' + valInput);

        var current = $(this);

        //console.log(textSearch.indexOf(valInput));

        //if( !~textSearch.indexOf(valInput) == -1)
        return !~textSearch.indexOf(valInput);
    }).removeClass('row-even').removeClass('row-show').addClass('dn');

    table_id = '#boost-table-wrap-' + index;
    $(table_id + " .row-show:even").addClass("row-even");

    console.log('key table_id: ' + table_id );
    //console.log('valInput = ' + valInput);
});

});




});



  

  //console.log('worked! 123 ' + table);
}
// DESTINATIONS TABLE


// READY
jQuery(window).on("load resize",function(e){

// LOADED
$('body').addClass('loaded');

destinationsTable();



});
// READY

// RANDOM WHOLE NUMBER GENERATOR
function randomWholeNumber(min, max) {
  number = Math.floor(Math.random() * (max - min + 1) + min);

  for (var i = 0; i < 10 && number == max + 1; i++) {
    number = Math.floor(Math.random() * (max - min) + min + 1) - 1;
  }

  return number;
}
// RANDOM WHOLE NUMBER GENERATOR

// COOKIES
function setCookie(key, value, expiry) {
  var expires = new Date();
  expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
  document.cookie = '___' + key + '=' + value + ';expires=' + expires.toUTCString() + ';domain=boost.com.au;path=/;SameSite=Lax'; 
  window.dataLayer.push({'event': 'cookie_' + key + '_' + value});
}

function getCookie(cname) {
  var name = '___' + cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      window.dataLayer.push({'event': 'cookie_g_' + cname + '_' + c.substring(name.length, c.length) });
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var audience_split = getCookie('audience_split');

if( audience_split == '') {

  console.log('splitting');
  audience_split = randomWholeNumber(0,1);
  if(audience_split == 0) {
    audience_split = 'a';
  }
  else if(audience_split == 1) {
    audience_split = 'b';
  }
  setCookie('audience_split', audience_split, 1);
  $('body').addClass('audience-' + audience_split);
  window.dataLayer.push({'event': 'AudienceSplit_' + audience_split});
}
else {
  console.log('split already');
  $('body').addClass('audience-' + audience_split);
  window.dataLayer.push({'event': 'AudienceSplit_' + audience_split});
}






// COOKIES

// RECHARGE COOKIE
$("#shopify-section-boost-button-group a:contains('RECHARGE')").on("click",function(e){
  setCookie('recharged', 'yes', 365);
});

var boost_recharged = getCookie('recharged');
var boost_recharge_complete = getCookie('recharge');

if( boost_recharged == 'yes' || boost_recharge_complete == 'complete') {
  $('body').addClass('recharged-yes'); 
}
else {
  $('body').addClass('recharged-no'); 
}
// RECHARGE COOKIE

// AUDIENCE

if(location.hostname != 'boost.com.au' && location.hostname != 'refurbished.boost.com.au') {
    $('.section-promo').each(function(){
      $(this).prepend('<div class="boost-audience-label tac"><span>AUDIENCE TYPE: ' + $(this).attr('data-audience') + '</span></div>');
    });
  $('body').addClass('recharged-yes').addClass('recharged-no').addClass('audience-a').addClass('audience-b');
}
else {
}

// AUDIENCE

function searchToggle() {
  document.querySelector('body').classList.toggle('search-enabled');
  document.getElementById("search").focus();
}

// Find and replace database errors
//mainFaq = $('main .boost-faq-product .faq__answer-wrapper .rte.text--pull:first-of-type').html();
//mainFaq = mainFaq.replaceAll('åÊ', '  ');
//mainFaq = mainFaq.replaceAll('å', ' ');
//mainFaq = mainFaq.replaceAll('‰۝', ' ');
//mainFaq = mainFaq.replaceAll('0̬?', '0˚');
//mainFaq = mainFaq.replaceAll('‰Û?', '"');
//$('main .boost-faq-product .faq__answer-wrapper .rte.text--pull:first-of-type').html(mainFaq);
//mainFaq = '';